import { cva } from 'class-variance-authority';

type LoadingIndicatorSize = 16 | 20 | 24 | 32 | 48 | 56 | 64;

const loadingIndicatorVariants = cva('flex items-center justify-center', {
  variants: {
    size: {
      16: 'w-4 h-4',
      20: 'w-5 h-5',
      24: 'w-6 h-6',
      32: 'w-8 h-8',
      48: 'w-12 h-12',
      56: 'w-14 h-14',
      64: 'w-16 h-16',
    },
  },
  defaultVariants: {
    size: 32,
  },
});

const getStrokeWidth = (size: LoadingIndicatorSize) => {
  const sizeToStrokeWidth: Record<LoadingIndicatorSize, number> = {
    16: 1,
    20: 1.5,
    24: 2,
    32: 2,
    48: 3,
    56: 3.5,
    64: 4,
  };
  return sizeToStrokeWidth[size] || 2;
};

const LoadingIndicator = ({ size = 32, _className = '' }: { size?: LoadingIndicatorSize; _className?: string }) => {
  const strokeWidth = getStrokeWidth(size);

  return (
    <div className={loadingIndicatorVariants({ size, className: _className })}>
      <svg width="100%" height="100%" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" className="animate-spin">
        <circle cx="25" cy="25" r="20" className="stroke-bg-tertiary" strokeWidth={strokeWidth} fill="none" />
        <circle
          cx="25"
          cy="25"
          r="20"
          className="stroke-fg-secondary"
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray="31.5, 125.6"
          transform="rotate(-90 25 25)"
        />
      </svg>
    </div>
  );
};

export default LoadingIndicator;
